import React, { Dispatch } from 'react';
import cn from 'classnames';
import styles from './CadenceToggle.module.scss';

export type PaymentCadence = 'monthly' | 'annually';

export default function CadenceToggle({
  className,
  cadence,
  setCadence,
}: {
  className: string;
  cadence: PaymentCadence;
  setCadence: Dispatch<PaymentCadence>;
}) {
  return (
    <div className={cn(className, styles.toggle, styles[cadence])}>
      <div
        className={cn(styles.option, styles.monthlyOption)}
        onClick={() => setCadence('monthly')}
      >
        Pay monthly
        <div className={styles.border} />
      </div>
      <div
        className={cn(styles.option, styles.annuallyOption)}
        onClick={() => setCadence('annually')}
      >
        Pay annually
        <div className={styles.border} />
      </div>
    </div>
  );
}
